// Faithful port of eb-ui `packages/eds/eds-share-box/src/TwitterShare.jsx`.
import React from 'react';
import { formatUrl } from 'url-lib';
import { IconButton } from '@eventbrite/legacy-eds.icon-button';
import { LogoTwitter } from '@eventbrite/legacy-eds.iconography';
import { gettext } from '../../i18n/gettext';
import { TWITTER_AFFILIATED_CODE } from './constants';
import { openUrl } from './utils';
import type { BaseShareProps, UtmOptions } from './types';

const TWITTER_URL = 'https://twitter.com/intent/tweet';

const _getEventUrl = (
    eventUrl: string,
    affiliateChannel: string | undefined,
    utmOptions: UtmOptions | undefined,
) =>
    formatUrl(eventUrl, {
        aff:
            (affiliateChannel && TWITTER_AFFILIATED_CODE[affiliateChannel]) ||
            TWITTER_AFFILIATED_CODE['default'],
        ...utmOptions,
    });

export interface TwitterShareProps extends BaseShareProps {
    twitterHandle: string;
}

export default class TwitterShare extends React.Component<TwitterShareProps> {
    _handleButtonClick() {
        const {
            affiliateChannel,
            eventName,
            eventUrl,
            onClick,
            twitterHandle,
            utmOptions,
        } = this.props;
        const text = gettext(
            'Check out "%(eventName)s" %(eventUrl)s @%(twitterHandle)s',
            {
                eventName,
                twitterHandle,
                eventUrl: _getEventUrl(eventUrl, affiliateChannel, utmOptions),
            },
        );
        const url = formatUrl(TWITTER_URL, { text });

        if (onClick) {
            onClick();
        }

        openUrl(url);
    }

    render() {
        return (
            <span
                className="eds-l-pad-right-1"
                data-spec="twitter-share-box-container"
                data-heap-id={this.props.dataHeapId}
                data-share-method={this.props.shareMethod}
                data-page-area={this.props.dataPageArea}
                data-event-id={this.props.eventId}
            >
                <IconButton
                    iconType={<LogoTwitter />}
                    title={gettext('Share on Twitter')}
                    onClick={this._handleButtonClick.bind(this)}
                />
            </span>
        );
    }
}
